<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

  import {splitOpenid} from './assets/js/commonFn.js';
  // import {getUrlKey} from './assets/js/commonFn.js';

  let curComponent;

  export default ({
    data() {
      return {
        weixinOpenid: '',
      }
    },
    created() {
      // 调用token 获取
      this.getFromUrlFn();
    },
    components: {},
    mounted() {
      // iOS禁止缩放
      window.onload = function () {
        document.addEventListener('touchstart', function (event) {
          if (event.touches.length > 1) {
            event.preventDefault()
          }
        })
        document.addEventListener('gesturestart', function (event) {
          event.preventDefault()
        })
      }
    },
    methods: {
      // 第一个全局变量好让子组件调用父组件的方法
      setComponent: function (component) {
        curComponent = component;
      },

      // 保存进入时的路由和openid
      getFromUrlFn() {
        let url = window.location.href;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // 记录进入的路由和openid
          if (url.indexOf("login?openid") != -1) {
            this.weixinOpenid = splitOpenid(url);
            window.localStorage.setItem('setWapWeixinOpenid', this.weixinOpenid);
          } else {
            window.localStorage.setItem('fromPath', url);
          }


        } else {
          window.localStorage.setItem('fromPath', url);

          let appToken = '';
          let btn = false;
          this.$bridge.callhandler('getToken', {}, (data) => {
            appToken = data.token;
            if (appToken) {
              btn = true;
            }
          });

          if (window.hasOwnProperty('Android')) {
            appToken = window.Android.getToken();
            if (appToken) {
              btn = true;
            }
          }

          // 判断是否切换了账号(只要是退出了APP,重新进入都会是新的APP token)
          if (btn) {
            let APPStorageToken = window.localStorage.getItem('APPStorageToken');

            if (!APPStorageToken || APPStorageToken != appToken) {
              // 把安卓token保存到本地缓存
              window.localStorage.setItem('APPStorageToken', appToken);

              // 通知token过期
              this.$store.commit('setTokenBe', 1);

              // 在调用一次获取H5 token
              this.$router.push('/login');
            }
          }
        }

      },

    },

  });

  // 安卓调用我的方法
  window["resultsPayment"] = function (data) {
    curComponent.resultFn(data);
  };

  window["resultsLocation"] = function (data) {
    //curComponent.ExposeAndroidAppAdder(data);
  };

</script>

<style lang="less">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 14px;
  }

  .van-step--vertical {
    padding-right: 0 !important;
  }
  .container{
    position: absolute;
    top: 0;
    left: 0;
    background: #F5f5f5;
    width: 100%;
    height: 100%;
  }

</style>
